import { Pagination, Dropdown, Popover } from "antd";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const Paget = ({ status, setStatus }) => {
  const QuotationFlow = useSelector((state) => state.QuotationFlow);
  const PsOrders = useSelector((state) => state.PsOrders);
  console.log(PsOrders);
  const SelectedCompanyVendor = useSelector(
    (state) => state.SelectedCompanyVendor
  );

  const router = useNavigate();
  const dispatch = useDispatch();
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [pagewithsearch, setPagewithsearch] = useState(1);
  const [cancelTokenSource, setCancelTokenSource] = useState(null);
  // const [status, setStatus] = useState(false);
  const [afterApi, setAfterApi] = useState(false);
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const [orderData, setOrderData] = useState([]);
  const role = useSelector((state) => state.role);

  // useEffect(() => {
  //   if (user === "employee" && role === "Permanent Secretary") {
  //     setStatus(PsOrders?.value);
  //   }
  // }, []);

  // setTotalPages(1);
  const items = [
    {
      label: "View ",
      key: "1",
    },
    {
      label: "Update",
      key: "5",
    },
    {
      label: "Delete ",
      key: "4",
    },
  ];

  const onClick = (key, item) => {
    console.log(key, item);
  };

  const columnHeaders = [
    "SR.",
    "Date",
    user === "vendor-owner" ? "Buyer" : "Vendor",
    ...(user === "employee" && role === "Permanent Secretary" ? ["Buyer"] : []), // Add "Buyer" only if user is not "vendor-owner"
    "Phone",
    "Product",
    "Status",
  ];

  useEffect(() => {
    setAfterApi(false);
    const delay = 200;

    const timeoutId = setTimeout(() => {
      // Cancel the previous request if it exists
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }

      // Create a new cancel token source for this request
      const newCancelTokenSource = axios.CancelToken.source();
      setCancelTokenSource(newCancelTokenSource);

      const params = {
        limit: 6,
        skip: (page - 1) * 6,
        sortBy: "quotationDate:desc",
        page: page,
        ...(status && { finalStatus: status }),

        // limit: 6,
        // skip:
        //   search || searchDob || countryCode || phoneNoo ? 0 : (page - 1) * 6,
        // page: search ? pagewithsearch : page, // Separate page for search and non-search scenarios
        // sortBy: "createdAt:desc",
        // ...(search && { search }),
        // ...(searchDob && { dateOfBirth: searchDob }),
        // ...(countryCode &&
        //   phoneNoo && { countryCode: `+${countryCode}`, phoneNo: phoneNoo }),
      };
      if (user === "vendor-owner") {
        if (SelectedCompanyVendor !== null) {
          params.vendorbranchId = SelectedCompanyVendor?.id;
        }
      }

      fetchOrders(params, newCancelTokenSource);
    }, delay);

    return () => {
      clearTimeout(timeoutId);

      // Cancel the request if the component is unmounted
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Operation canceled by the user.");
      }
    };
  }, [page, pagewithsearch, status]);

  const fetchOrders = (params, cancelTokenSource) => {
    // const api =
    //   user === "vendor-owner"
    //     ? "v1/inv-order/vendor-list-quotations"
    //     : user === "employee" && role === "Permanent Secretary"
    //     ? "v1/inv-order/ps-list-quotations"
    //     : "v1/inv-order/buyer-list-quotations";

    const api =
      user === "vendor-owner"
        ? "v1/inv-order/vendor-list-quotations"
        : PsOrders?.value === "all-quotations" 
        ? "v1/inv-order/mhsss-list-quotations"
        : "v1/inv-order/buyer-list-quotations";
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/${api}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        cancelToken: cancelTokenSource.token,
      })
      .then((data) => {
        setOrderData(data?.data?.rows);
        setTotalPages(data?.data?.totalPages);
        setAfterApi(true);
      })
      .catch((err) => {
        console.log(err);
        setAfterApi(true);
      });
  };

  const pageHandler = (e) => {
    if (search) {
      // If searching, update searchPage
      setPagewithsearch(e);
    } else {
      // If not searching, update page
      setPage(e);
    }
  };

  return (
    <>
      <section className="w-full pl-6 pr-6 mb-5">
        <div className="mx-auto max-w-screen-xl ">
          <div className="relative sm:rounded-lg overflow-hidden">
            {/* Search */}
            <div className="flex justify-end mt-4 gap-3 mb-3">
              {/* <div className="flex items-center bg-[#f9fbfb] border border-gray-300 rounded-md px-4 py-2 w-[300px] shadow-sm">
                <input
                  type="text"
                  placeholder="Search Order"
                  className="bg-transparent focus:outline-none text-gray-500 placeholder-gray-400 flex-grow"
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-[#1BA397]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.8"
                    d="M11 19a8 8 0 100-16 8 8 0 000 16zm5-1l5 5"
                  />
                </svg>
              </div> */}
            </div>
            <div className="overflow-x-auto w-full h-full rounded-tl-lg rounded-tr-lg custom-scrollbar">
              <table className="w-full text-sm text-left text-gray-500 ">
                <thead className="text-xs  uppercase bg-primary text-white">
                  <tr>
                    {columnHeaders.map((columnHeader) => (
                      <th
                        scope="col"
                        className="px-4 py-3 font-semibold tracking-wider whitespace-nowrap"
                      >
                        {columnHeader}
                      </th>
                    ))}
                  </tr>
                </thead>
                {orderData?.length === 0 ? (
                  <tbody>
                    <tr>
                      <td
                        colSpan="9"
                        className="text-center text-gray-500 text-lg"
                      >
                        <p className="p-10">No data found</p>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {orderData?.map((data, index) => (
                      <tr
                        onClick={() => {
                          dispatch({ type: "QUOTATION_FLOW", num: true });
                          dispatch({ type: "ORDER_DATA", num: data });
                          router("/Inventory-Vendor-Orders-Details");
                        }}
                        className={`border-b border-[1px] border-[#d9d9d970] hover:bg-gray-200 text-md cursor-pointer ${
                          index % 2 === 0 ? "bg-white" : "bg-[#f2faf9]"
                        }`}
                      >
                        <th
                          scope="row"
                          className="px-4 py-3 font-medium text-gray-900  whitespace-nowrap "
                        >
                          {search
                            ? index + 1 + (pagewithsearch - 1) * 6
                            : index + 1 + (page - 1) * 6}
                          .
                        </th>
                        {/* <td className="px-4 py-3 whitespace-nowrap capitalize">
                          <Popover content={data?.purchasedNo}>
                            <div className="inline-block  items-center justify-center max-w-[120px] whitespace-nowrap overflow-hidden overflow-ellipsis">
                              {data?.purchasedNo.substring(0, 5)}..
                            </div>
                          </Popover>
                        </td> */}
                        <td className="px-4 py-3 whitespace-nowrap capitalize">
                          <div className="flex flex-col">
                            <p className="text-gray-500 font-semibold">
                              {data?.quotationDate
                                ? moment(data?.quotationDate)?.format(
                                    "MM/DD/YYYY"
                                  )
                                : "-------"}
                            </p>
                            <p className="text-gray-400 font-semibold">
                              {data?.quotationDate
                                ? moment(data?.quotationDate)?.format("hh:mm A")
                                : "-----"}
                            </p>
                          </div>
                        </td>

                        <td
                          className={`${
                            user === "vendor-owner" ? "px-6 py-5" : "hidden"
                          }`}
                        >
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-10 w-10">
                              <img
                                className="h-10 w-10 rounded-full border-2 border-primary"
                                src={
                                  data?.user?.person?.image
                                    ? data?.user?.person?.image
                                    : ""
                                }
                                alt=""
                              />
                            </div>
                            <div className="ml-4">
                              {data?.user?.person?.firstName
                                ? data.user.person.firstName
                                : "-----"}{" "}
                              {data?.user?.person?.lastName
                                ? data.user.person.lastName
                                : ""}
                            </div>
                          </div>
                        </td>
                        <td
                          className={`${
                            user === "vendor-owner" ? "hidden" : "px-6 py-5"
                          }`}
                        >
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-10 w-10">
                              <img
                                className="h-10 w-10 rounded-full border-2 border-primary"
                                src={
                                  data?.vendorbranch
                                    ? data?.vendorbranch?.logo
                                    : data?.vendorcompany?.logo
                                }
                                alt=""
                              />
                            </div>
                            <div className="ml-4">
                              {data?.vendorbranch
                                ? data?.vendorbranch?.name
                                : data?.vendorcompany?.name}
                            </div>
                          </div>
                        </td>
                        <td
                          className={`${
                            user === "employee" &&
                            role === "Permanent Secretary"
                              ? "px-6 py-5"
                              : "hidden"
                          }`}
                        >
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-10 w-10">
                              <img
                                className="h-10 w-10 rounded-full border-2 border-primary"
                                src={
                                  data?.user?.person?.image
                                    ? data?.user?.person?.image
                                    : ""
                                }
                                alt=""
                              />
                            </div>
                            <div className="ml-4">
                              {data?.user?.person?.firstName
                                ? data.user.person.firstName
                                : "-----"}{" "}
                              {data?.user?.person?.lastName
                                ? data.user.person.lastName
                                : ""}
                            </div>
                          </div>
                        </td>

                        <td className="px-6  py-5">
                          {data?.user?.countryCode
                            ? `${data?.user?.countryCode} ${data?.user?.phoneNo}`
                            : "------"}
                        </td>

                        {/* <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            <div className="flex-shrink-0 h-10 w-10">
                              <img
                                className="h-10 w-10 rounded-full border-2 border-primary"
                                src={
                                  "data:image/jpeg;base64,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"
                                }
                                alt=""
                              />
                            </div>
                            <div className="ml-4">{data?.product}</div>
                          </div>
                        </td> */}

                        <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                          <div className="flex items-center">
                            {data?.invorderitems
                              ?.slice(0, 3)
                              .map((item, index) => {
                                // Find the cover image from the invproductgallaries array
                                const coverImage =
                                  item.invproduct?.invproductgallaries?.find(
                                    (gallery) => gallery.isCoverImg
                                  )?.image;

                                return (
                                  <img
                                    key={item.id}
                                    src={
                                      coverImage ||
                                      "https://via.placeholder.com/40"
                                    } // Fallback image URL
                                    alt={item.invproduct?.name || "Product"}
                                    className={`w-10 h-10 rounded-full border-2 border-blueGray-50 shadow ${
                                      index > 0 ? "-ml-4" : ""
                                    }`}
                                  />
                                );
                              })}

                            {/* Show +n for remaining items */}
                            {data?.invorderitems?.length > 3 && (
                              <span className=" w-10 h-10 flex items-center justify-center  text-blueGray-700 text-sm font-semibold ml-2">
                                +{data.invorderitems.length - 3}
                              </span>
                            )}
                          </div>
                        </td>

                        <td className="px-4 py-3 whitespace-nowrap">
                          <div
                            className={`${
                              data?.finalStatus === "completed"
                                ? "bg-primary text-green-500 rounded-lg pl-2 pr-2 p-1"
                                : 
                                  data?.finalStatus === "vendor-rejected-quot"
                                ? "bg-red-200 text-red-700 rounded-lg pl-2 pr-2 p-1":
                                data?.finalStatus === "rejected" ||
                                  data?.finalStatus === "cancelled" 
                                  
                                ? "bg-red-100 text-red-500 rounded-lg pl-2 pr-2 p-1"

                                : data?.finalStatus === "Processing"
                                ? "bg-gray-100 text-gray-500 rounded-lg pl-2 pr-2 p-1"
                                : data?.finalStatus === "vendor-accepted-quot"
                                ? "bg-green-100 text-green-500 rounded-lg pl-2 pr-2 p-1"
                                : "bg-blue-100 text-blue-500 rounded-lg pl-2 pr-2 p-1"
                            } text-center font-semibold capitalize`}
                          >
                            {data?.finalStatus === "vendor-accepted-quot"
                              ? "Quotation Accepted"
                              : data?.finalStatus === "vendor-rejected-quot"
                              ? "Quotation Rejected"
                              : data?.finalStatus === "Cancelled"
                              ? "Cancelled"
                              : data?.finalStatus === "Rejected"
                              ? "Rejected"
                              : data?.finalStatus === "Completed"
                              ? "Completed"
                              : data?.finalStatus === "Processing"
                              ? "Processing"
                              : data?.finalStatus === "Pending"
                              ? "Pending"
                              : data?.finalStatus}
                          </div>
                        </td>
                        {/* <td className="px-6  py-5">
                          <Dropdown
                            menu={{
                              items,
                              onClick: (key) => onClick(key, items),
                            }}
                            trigger={["click"]}
                            onClick={() => {}}
                          >
                            <div className="w-[2.8rem] flex gap-1 cursor-pointer bg-[#f5f6fb] justify-center items-center h-[1.2rem] rounded-[1rem]">
                              <div className="h-[4px] w-[4px] rounded-full bg-gray-900"></div>
                              <div className="h-[4px] w-[4px] rounded-full bg-gray-900"></div>
                              <div className="h-[4px] w-[4px] rounded-full bg-gray-900"></div>
                            </div>
                          </Dropdown>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
            <nav
              className="flex bg-white flex-col h-[5.5rem] md:flex-row justify-center items-start md:items-center space-y-3 md:space-y-0 p-4 rounded-bl-lg rounded-br-lg"
              aria-label="Table navigation"
            >
              <span className="text-sm font-normal text-gray-500 ">
                Showing{" "}
                <span className="font-semibold text-gray-900 ">
                  Page {page}{" "}
                </span>
                of{" "}
                <span className="font-semibold text-gray-900 ">
                  {totalPages}
                </span>
              </span>
              <div className={`flex justify-end mt-7`}>
                <Pagination
                  defaultCurrent={1}
                  total={totalPages * 10}
                  showSizeChanger={false}
                  onChange={pageHandler}
                  current={page}
                />
              </div>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
};

export default Paget;
